<template>
  <!-- Healthy: data is flowing -->
  <div
    v-if="lastReceived"
    v-tooltip.bottom="`Data last received ${timeAgo}`"
    class="flex size-8 shrink-0 items-center justify-center"
  >
    <span class="h-2 w-2 shrink-0 rounded-full bg-green-500" />
  </div>

  <!-- Waiting: no data has ever been received (snippet likely not installed).
       Hidden while loading or when the query errored — a transient reporting
       hiccup must not look like a missing snippet. -->
  <router-link
    v-else-if="!isLoadingDataLastReceived && !isErrorDataLastReceived"
    v-tooltip.bottom="'No visitor data yet — install your tracking snippet to go live'"
    :to="{ name: ROUTES.SETTINGS_SNIPPET }"
    aria-label="Waiting for data — install your tracking snippet"
    class="flex size-8 shrink-0 items-center justify-center rounded-full hover:bg-rose-500/10"
  >
    <span class="relative flex h-2 w-2 shrink-0">
      <span class="absolute inline-flex h-full w-full animate-ping rounded-full bg-rose-400 opacity-75" />
      <span class="relative inline-flex h-2 w-2 rounded-full bg-rose-500" />
    </span>
  </router-link>
</template>

<script setup lang="ts">
import { ROUTES } from '@/router/routeNames'

const reportStore = useReportStore()
const { dataLastReceived, isLoadingDataLastReceived, isErrorDataLastReceived } = storeToRefs(reportStore)

const lastReceived = computed(() => {
  return dataLastReceived.value?.last_update
})

const timeAgo = useTimeAgo(computed(() => lastReceived.value ?? new Date()))
</script>
